export default function PrivacyPage() {
  return (
    <div className="prose prose-sm max-w-none text-text">
      <h1 className="font-display text-2xl font-bold">Privacy Policy</h1>
      <p className="text-sm text-text-secondary">Last updated: May 2026</p>

      <p className="mt-4">
        ISPYFR is operated by South Fork Mobile LLC, DBA South Fork Games.
      </p>

      <h2 className="mt-6 text-lg font-semibold">What We Collect</h2>
      <p>
        ISPYFR collects only the minimum information needed to run a game
        session:
      </p>
      <ul className="list-disc space-y-1 pl-5">
        <li>
          <strong>Display name</strong> — chosen by you when joining a game.
          This is not linked to any account or real identity.
        </li>
        <li>
          <strong>Photos</strong> — submitted as part of gameplay. Photos are
          stored temporarily and deleted after the game ends.
        </li>
      </ul>
      <p>We do not collect email addresses, phone numbers, or passwords.</p>

      <h2 className="mt-6 text-lg font-semibold">How We Use Your Information</h2>
      <p>
        Display names and photos are used solely to operate the game you joined.
        They are never shared outside your game session, sold, or used for
        marketing.
      </p>

      <h2 className="mt-6 text-lg font-semibold">Data Retention</h2>
      <p>
        All game data — including photos, display names, and game state — is
        automatically deleted after a short retention window following the end of
        a game. No data is stored long-term.
      </p>

      <h2 className="mt-6 text-lg font-semibold">Cookies &amp; Tracking</h2>
      <p>
        ISPYFR uses browser local storage to remember your active game sessions
        and your analytics preferences. With your consent, we use Google
        Analytics to collect anonymous usage data (pages visited, general
        device/browser info) to help improve the site. Google Analytics may set
        cookies on your device. You can change your preference at any time by
        clearing your browser&apos;s local storage. No individual user profiles
        are created. We do not use analytics data for advertising.
      </p>

      <h2 className="mt-6 text-lg font-semibold">Advertising</h2>
      <p>
        We may display ads provided by Google AdSense in the future. If ads are
        enabled, Google may use cookies to serve ads. We will update this policy
        when advertising is activated. You can opt out of personalized
        advertising by visiting{" "}
        <a
          href="https://www.google.com/settings/ads"
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary hover:underline"
        >
          Google Ads Settings
        </a>
        .
      </p>

      <h2 className="mt-6 text-lg font-semibold">Children&apos;s Privacy</h2>
      <p>
        ISPYFR is not directed at children under 13. We do not knowingly collect
        personal information from children. If you believe a child has provided
        us with personal information, please contact us so we can take
        appropriate action.
      </p>

      <h2 className="mt-6 text-lg font-semibold">Changes to This Policy</h2>
      <p>
        We may update this policy from time to time. Changes will be reflected
        on this page with an updated date.
      </p>

      <h2 className="mt-6 text-lg font-semibold">Contact Us</h2>
      <p>
        If you have questions about this privacy policy, please contact us at{" "}
        <a
          href="mailto:support@ispyfr.com"
          className="text-primary hover:underline"
        >
          support@ispyfr.com
        </a>
        .
      </p>
    </div>
  );
}
